import { render, staticRenderFns } from "./componentCol.vue?vue&type=template&id=382dc888&"
import script from "./componentCol.vue?vue&type=script&lang=js&"
export * from "./componentCol.vue?vue&type=script&lang=js&"
import style0 from "./componentCol.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports